import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";
import {
  IInfoPlanDevice,
  IClientInfo,
} from "../../provider/micelu.provider.interfaces";

interface IProps {
  children: ReactNode;
}

interface IAuthAgent {
  email: string;
  password: string;
}

type IContext = {
  step: number;
  user: IAuthAgent | null;
  client: IClientInfo | null;
  infoPlanDevice: IInfoPlanDevice | null;
  touchID: string | null;
  infoPayment: any;
  setInfoPayment: Dispatch<SetStateAction<any>>;
  setStep: Dispatch<SetStateAction<number>>;
  setUser: Dispatch<SetStateAction<IAuthAgent | null>>;
  setInfoPlanDevice: Dispatch<SetStateAction<IInfoPlanDevice | null>>;
  setClient: Dispatch<SetStateAction<IClientInfo | null>>;
  setTouchID: Dispatch<SetStateAction<string | null>>;
  handleInitialState: () => void;
};

export const CreateUsedMiCeluContext = React.createContext<IContext>(
  {} as IContext,
);
export const useCreateUsedMiCeluContext = () =>
  useContext<IContext>(CreateUsedMiCeluContext);

const CreateUsedMiCeluProvider = ({ children }: IProps) => {
  const [step, setStep] = useState<number>(1);
  const [user, setUser] = useState<IAuthAgent | null>(null);
  const [infoPlanDevice, setInfoPlanDevice] = useState<IInfoPlanDevice | null>(
    null,
  );
  const [touchID, setTouchID] = useState<string | null>(null);
  const [client, setClient] = useState<IClientInfo | null>(null);
  const [infoPayment, setInfoPayment] = useState<any>(null);
  const handleInitialState = () => {
    setStep(1);
    setUser(null);
    setInfoPlanDevice(null);
    setClient(null);
    setTouchID(null);
    setInfoPayment(null);
  };

  const context: IContext = useMemo(
    () => ({
      step,
      user,
      infoPlanDevice,
      client,
      infoPayment,
      touchID,
      setStep,
      setUser,
      setInfoPlanDevice,
      setClient,
      setTouchID,
      setInfoPayment,
      handleInitialState,
    }),
    [step, user, infoPlanDevice, client, touchID, infoPayment],
  );
  return (
    <CreateUsedMiCeluContext.Provider value={context}>
      {children}
    </CreateUsedMiCeluContext.Provider>
  );
};

export default CreateUsedMiCeluProvider;
